/**
 * Redirects migrated tenants from the legacy platform to Real Links 2.0.
 * Runs on the client for any route (including /login and Minimal layout), once company is known.
 * A company page stays put only when it was opened from the admin panel.
 * Tenants not listed here: no redirect; behaviour unchanged from before migration redirects.
 */
function isOpenedFromAdminPanel() {
  let referrer = '';
  try {
    referrer = document.referrer || '';
  } catch (err) {
    return false;
  }

  return referrer.startsWith('https://admin.reallinks.io') ||
    referrer.startsWith('https://admin.reallinks.dev') ||
    referrer.startsWith('http://localhost:8080');
}

export function redirectToNewPlatformIfEligible(vm) {
  if (process.env.VUE_ENV !== 'client' || typeof window === 'undefined') {
    return;
  }
  if (process.env.ADMIN_UI) {
    return;
  }

  const root = vm && vm.$root;
  if (!root) {
    return;
  }

  if (isOpenedFromAdminPanel()) {
    return;
  }

  const go = (url) => {
    try {
      window.localStorage.clear();
      window.sessionStorage.clear();
    } catch (err) {
      // Storage can throw in private mode. The redirect still has to win.
    }
    window.location.replace(url);
  };

  if (root.isEXPD8) {
    go('https://default.expd8rewards.reallinks.app');
    return;
  }
  if (root.isERM) {
    go('https://default.erm.reallinks.app');
    return;
  }
  if (root.isGROWMARK) {
    go('https://default.growmark.reallinks.app');
    return;
  }
  if (root.isHelloFresh) {
    go('https://default.hellofresh.reallinks.app');
    return;
  }
  if (root.isBT) {
    go('https://default.bt.reallinks.app');
    return;
  }
  if (root.isBerenschot) {
    go('https://default.berenschot.reallinks.app');
    return;
  }
  if (root.isBallastNedam) {
    go('https://default.ballast-nedam.reallinks.app');
    return;
  }
  if (root.isOptiverInterns) {
    go('https://default.optiver.reallinks.app');
    return;
  }
  if (root.isCapco) {
    go('https://default.capco.reallinks.app');
    return;
  }
  if (root.isApplusIdiada) {
    go('https://default.idiada.reallinks.app');
    return;
  }
  if (root.isAssurant) {
    go('https://default.assurant.reallinks.app');
    return;
  }
  if (root.isTrinityHomecare) {
    go('https://default.trinityhomecare.reallinks.app');
  }
}



// WEBPACK FOOTER //
// ./src/lib/platformMigrationRedirect.js